import { Component, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
// translations removed
import { FormControlNames } from '../../shared/enums';
import { ResetPassword } from '../../shared/models/rest-password.model';
import { PasswordErrorService } from '../../shared/services/password-error.service';
import { createPasswordForm } from '../../shared/utils/password-form.util';
import { PasswordRecoveryService } from '../password-recovery/services/password-recovery.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
  standalone: false,
})
export class PasswordResetComponent implements OnInit {
  resetEnabled = false;
  username!: string;
  token!: string;
  resetPassword: ResetPassword = {} as ResetPassword;
  passwordForm!: FormGroup;
  passwordControl!: FormControl;

  constructor(
    private passwordErrorService: PasswordErrorService,
    private router: Router,
    private route: ActivatedRoute,
    private passRecoveryService: PasswordRecoveryService,
    private snackBar: MatSnackBar,
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.username = params['username'];
      this.token = params['passwordResetToken'];
    });
  }

  private initForm(): void {
    const { passwordControl, confirmPasswordControl, passwordForm } = createPasswordForm(this.passwordErrorService);
    this.passwordControl = passwordControl;
    this.passwordForm = passwordForm;

    // Keep subscriptions in the component so takeUntilDestroyed is evaluated in
    // the correct component lifecycle/injection context.
    this.passwordControl.valueChanges.pipe(takeUntilDestroyed()).subscribe((value) => {
      this.resetPassword.password1 = value;
    });

    confirmPasswordControl.valueChanges.pipe(takeUntilDestroyed()).subscribe((value) => {
      if (value != null) {
        this.resetPassword.password2 = value;
      }
    });
  }

  getPasswordErr(): string {
    return this.passwordErrorService.getPasswordErr(this.passwordControl);
  }

  getConfirmPwdErr(): string {
    return this.passwordErrorService.getConfirmPwdErr(this.passwordForm.controls[FormControlNames.CONFIRM_PASSWORD]);
  }

  onFocus(): void {
    this.passwordForm.get(FormControlNames.CONFIRM_PASSWORD)?.markAsTouched();
  }

  reset(): void {
    this.passRecoveryService.resetPassword(this.username, this.token, this.resetPassword).subscribe(
      () => {
        this.router.navigate(['/']);
        setTimeout(() => {
          this.snackBar.open('Password Changed Successfully', 'Close', {
            duration: 10000,
            panelClass: ['snackbar-success'],
          });
        }, 800);
      },
      (error) => {
        // Some tests provide a translation key in error.error.message. Map known keys to friendly English fallback.
        // Default friendly fallback message
        const errorMessage = 'An error occurred: Password could not be changed';
        this.snackBar.open(errorMessage, 'Close', {
          duration: 8000,
          panelClass: ['snackbar-error'],
        });
      },
    );
  }
}
